import React, { useEffect, useState } from 'react';
import { webview } from '../../../app/api/webview';
import MobileView from './MobileView';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { use } from 'react';

const Reimbursement = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const [reimbId,setReimbId]=useState('');
  const [isSPOCRequest,setSPOCRequest]=useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const reimbId = queryParams.get('id'); 
      const isSpocRequest = queryParams.get('isSpocRequest'); 
    console.log('Received userId:', isSpocRequest);
  
    setReimbId(reimbId)
    setSPOCRequest(isSpocRequest)
    // You can now use userId for further logic like API calls
  }, [location]);
  useEffect(() => {
    const handlePopState = () => {
      navigate('/home/announcement/gatewaybox');
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        console.log('message', event.data);
        const message = event.data;
        if (message.type == 'GBOXClose') {
          // dispatch(toggleOutlet(false));
          navigate('/home/announcement/gatewaybox');
          console.log('GBOXClose');
        }
      } catch (error) {}
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  return <MobileView URL={webview.TD_Reimbursement} id={reimbId}  isSPOCRequest ={isSPOCRequest} comingSoon={false} />;
};

export default Reimbursement;
